import { stringify } from 'qs';
import request from '../request';
import { url } from '../service-utils';

/**
 * 会议详情
 * 陈陈
 * @param {string}} meetinginfoid
 */
export async function getDetail(payload) {
  const params = { ...payload };
  return request(`${url.meetingSign}/meeting/info/get?${stringify(params)}`);
}

/**
 * 会议参与人列表
 * 陈陈
* @param {string}} meetinginfoid
 */
export async function getParticipant(payload) {
  const params = { ...payload };
  return request(`${url.meetingSign}/meeting/users/getParticipantUsers?${stringify(params)}`);
}

/**
 * 发布会议
 * 陈陈
 * @param {string} meetinginfoid
 */
export async function pushMeeting(payload) {
  const params = { ...payload };
  return request(`${url.meetingSign}/meeting/info/publish?${stringify(params)}`);
}

/**
 * 删除会议
 * 陈陈
 * @param {string} meetinginfoid
 */
export async function delMeeting(payload) {
  const params = { ...payload };
  return request(`${url.meetingSign}/meeting/info/delete?${stringify(params)}`);
}

/**
 * 请假
 * 陈陈
 * @param {string} meetingInfoId
 * @param {string} reason
 */
export async function sendReason(payload) {
  const params = { ...payload };
  return request(`${url.meetingSign}/meeting/leave/add`,{
    method:'POST',
    data:params
  });
}

/**
 * 确认参加
 * 陈陈
 * @param {string} meetingInfoId
 */
export async function confirmAttend(payload) {
  const params = { ...payload };
  return request(`${url.meetingSign}/meeting/users/join?${stringify(params)}`);
}

/**
 * 取消请假
 * 陈陈
 * @param {string} meetingInfoId
 */
export async function cancelLeave(payload) {
  const params = { ...payload };
  return request(`${url.meetingSign}/meeting/leave/cancel_leave?${stringify(params)}`);
}
